import React, { useState } from "react";
import { Button, Card, Form, message } from "antd";
import DatepickerRanger from "../toolbox/DatepickerRanger";
import strings from "../../utils/Localization";
import KasaSelectOption from "../toolbox/KasaSelectOption";
import DovizSelectOption from "../toolbox/DovizSelectOption";
import moment from "moment";
import useVarsayilanDeger from "../../hooks/useVarsayilanDeger";
import useApi from "../../hooks/useApi";

export default function KasaRaporForm() {
  const [fetchLoading, setFetchLoading] = useState(false);
  const { kasaRaporForm } = strings.kasaRapor.components;
  const { getDefaultSetting } = useVarsayilanDeger();
  const [form] = Form.useForm();
  const api = useApi();

  const onFinish = async (values) => {
    try {
      const { tarih, kasaId, dovizId } = values;

      const baslangicTarihi = moment(tarih[0]).format("YYYY-MM-DD");
      const bitisTarihi = moment(tarih[1]).format("YYYY-MM-DD");

      const pdfWindow = window.open(`${document.location.origin}/#/RaporYukleniyor`);
      setFetchLoading(true);
      const response = await api.post(
        "/rapordosya/kasa",
        {
          BaslangicTarih: `${baslangicTarihi} 00:00:00`,
          BitisTarih: `${bitisTarihi} 23:59:59`,
          KasaId: kasaId === undefined ? 0 : kasaId,
          DovizId: dovizId === undefined ? 0 : dovizId,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        pdfWindow.document.location.href = response.data.data;
      }
    } catch (error) {
      message.error(error.message);
    } finally {
      setFetchLoading(false);
    }
  };

  const onValuesChange = (changedValues) => {
    if (Object.keys(changedValues).find((x) => x === "dovizId") !== undefined) {
      form.setFieldsValue({ kasaId: undefined });
    }
  };

  return (
    <Card>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        initialValues={{
          tarih: [moment().add("months", -12), moment()],
          dovizId: getDefaultSetting("doviz"),
        }}
        onValuesChange={onValuesChange}
      >
        <Form.Item
          name="tarih"
          label={kasaRaporForm.tarihSeciniz}
          rules={[{ required: true }]}
        >
          <DatepickerRanger />
        </Form.Item>
        <Form.Item name="dovizId" label={strings.dovizSelectOption.dovizBaslik}>
          <DovizSelectOption allowClear />
        </Form.Item>
        <Form.Item
          shouldUpdate={(prevValues, currentValues) =>
            prevValues.dovizId !== currentValues.dovizId
          }
        >
          {({ getFieldValue }) => {
            const currentDovizId = getFieldValue("dovizId");

            return (
              <Form.Item name="kasaId" label={kasaRaporForm.kasaSeciniz}>
                <KasaSelectOption
                  requestBody={{
                    Data: {
                      dovizId: currentDovizId,
                    },
                  }}
                  disabled={currentDovizId === undefined ? true : false}
                  placeholder={
                    currentDovizId === undefined
                      ? kasaRaporForm.tumKasalar
                      : undefined
                  }
                  allowClear
                />
              </Form.Item>
            );
          }}
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          style={{ float: "right" }}
          size="large"
          loading={fetchLoading}
        >
          {kasaRaporForm.raporAlButon}
        </Button>
      </Form>
    </Card>
  );
}
